export default __webpack_public_path__ + "static/media/IT.a3c32b52.jpeg";